<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-2" (click)="setOwnerAsk()" *ngIf="data.owner && data.owner === '0'">
		Przypisz do siebie
	</button>
	<!-- <button class="btn btn-warning me-2" (click)="deleteAsk()">Usuń</button> -->
	<button class="btn btn-info me-2" routerLink="./history">Historia</button>
	<button class="btn btn-primary me-2" routerLink="./edit">Szczegóły</button>
	<a class="btn btn-danger" routerLink="../" [fragment]="data.id"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="card">
	<div class="card-body">
		<div class="card-text row">
			<div class="col-sm-11 text-center">
				<button
					type="button"
					class="btn me-2"
					*ngFor="let item of statuses"
					[ngClass]="{
						'btn-primary': item.id === status,
						'btn-outline-primary': item.id !== status,
					}"
					(click)="setStatusAsk(item.id)"
				>
					{{ item.name }}
				</button>
				<div class="card alert-warning mt-3" *ngIf="showAskReason">
					<div class="card-body">
						<h5 class="card-title">Powód odrzucenia</h5>
						<div class="card-text">
							<form (submit)="resignSave()">
								<ng-select
									name="resignReason"
									[(ngModel)]="resignReason"
									[items]="resigns"
									placeholder="wybierz"
									bindLabel="name"
									bindValue="id"
								>
								</ng-select>
								<div class="row mt-3">
									<div class="col-sm-6 d-grid">
										<button class="btn btn-primary" type="submit">Zapisz</button>
									</div>
									<div class="col-sm-6 d-grid">
										<button class="btn btn-danger" (click)="showAskReason = false">Anuluj</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-1 text-end">
				<button type="button" class="btn btn-outline-primary" (click)="statusesInfo = !statusesInfo">
					<i class="fas fa-info"></i>
				</button>
			</div>
		</div>
	</div>
</div>
<div class="card" *ngIf="statusesInfo">
	<div class="card-body">
		<ul class="card-text">
			<li><b>NOWY</b> - status początkowy -> kontakt do obsłużenia</li>
			<li><b>NIE ODBIERA</b> - Aktualnie brak kontaktu, wybrany status oznacza, że ponowimy próbę kontaktu</li>
			<li>
				<b>WERYFIKACJA</b> -  klienta interesuje oferta BP OSKAR i została wysłana konkretna oferta. Status
				oznacza oczekiwanie na decyzję klienta: albo akceptację oferty, albo jej odrzucenie
			</li>
			<li>
				<b>ZAINTERESOWANY</b> - klienta interesuje oferta BP OSKAR, ale w tym momencie nie chce otrzymać, żadnej
				konkretnej oferty, bądź już otrzymał ofertę ale w tym momencie nie chce się na nią zdecydować
			</li>
			<li>
				<b>NIEZAINTERESOWANY</b> - klienta nie interesuje oferta BP OSKAR, mało prawdopodobne, że w przyszłości
				będzie nią zainteresowany
			</li>
			<li>
				<b>KONWERTOWANIE</b> - lead założył rezerwację w IStour, status daje możliwość połączenia leada z
				dokonaną rezerwacją
			</li>
			<li><b>CZARNA LISTA</b> - Klient nie życzy sobie kontaktu z naszej storny w przyszłości</li>
			<li><b>ARCHIWUM</b> - lead, który np. był zrobiony testowo i nie powinien być traktowany jako kontakt</li>
		</ul>
	</div>
</div>

<div class="card">
	<div class="card-body">
		<div class="card-text">
			<div class="row">
				<div class="col-sm-8">
					<div class="card">
						<div class="card-body">
							<div class="card-text">
								<app-leads-show-detail
									[lead]="data"
									[types]="types"
									[sources]="sources"
									[users]="users"
								></app-leads-show-detail>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="card">
						<div class="card-body">
							<h5 class="card-title">Notatka</h5>
							<div class="card-text">
								<form (submit)="noteSave()">
									<div class="mb-3">
										<textarea
											class="form-control"
											rows="3"
											name="note"
											[(ngModel)]="data.note"
										></textarea>
									</div>
									<div class="d-grid">
										<button class="btn btn-outline-primary" type="submit">Zapisz</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card">
	<div class="card-body">
		<div class="card-text">
			<div class="row">
				<div class="col-sm-8">
					<app-php-tasks objType="leads" [objId]="data.id"></app-php-tasks>
					<!--
					<app-leads-show-tasks
						[leadId]="lead.id"
						[tasks]="tasks"
						[users]="users"
						(changed)="loadData()"
					></app-leads-show-tasks>
-->
				</div>
				<div class="col-sm-4">
					<app-leads-show-tags
						[leadId]="data.id"
						[tags]="data.tags"
						(changed)="tagChanged()"
					></app-leads-show-tags>
				</div>
			</div>
		</div>
	</div>
</div>
